mando = window.mando || {};

mando.strings = {
    URL_Login: '/account/login',
    URL_MoreService: '/Navigation/ServiceCategories?page=2',
    //URL_MoreService: '/_common/js/services/more-council-services-TESTDATA.htm',
    CookieName_Announcement: 'Announcements_',
    Param_DoLogin: 'doLogin',
    Param_RedirectUrl: 'redirectUrl'
};

mando.setCookie = function (cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));

    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires + ";path=/";
};

mando.isPageEditor = function () {
    return $("html").hasClass("sitecore-page-editor");
};

mando.isPagePreview = function () {
    return $("html").hasClass("sitecore-page-preview");
};

mando.getUrlParameter = function (key) {
    var value = '';

    var queryString = window.location.search.substring(1);
    var vars = queryString.split("&");

    for (var i = 0; i < vars.length; i++) {
        var splitItem = vars[i].split("=");

        if (splitItem.length != 2)
            continue;

        if (splitItem[0] == key) {
            value = splitItem[1];
            break;
        }
    }

    return value;
};

mando.resetFormValidation = function(form) {

    form.validate().resetForm();

    form.find("[data-valmsg-replace]")
           .removeClass("field-validation-error")
           .addClass("field-validation-valid")
           .empty();
};